import React, { useState, useEffect, Fragment } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useHistory,
  Redirect,
  useLocation,
  useParams,
} from "react-router-dom";
import "./index.scss";
import { useTranslation } from "react-i18next";
import "react-loading-skeleton/dist/skeleton.css";
import { useSelector } from "react-redux";
import Host from "../../Components/Host";
import { useGetUserDataQuery } from "../../services/login";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PhoneIcon from "@mui/icons-material/Phone";
import HelmetComponent from "../../Components/HelmetComponent";
function TermsConditions() {
  const { userId, userToken, userEmail, userName, isMember, isPaymentMethod, languageCode, countryCode } = useSelector(
    (state) => state.auth
  );
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const [getSearchId, setSearchId] = useState("");

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth"
    });
  }, []);

  const { data: userData } = useGetUserDataQuery(
    { userId: userId, userToken: userToken, countryCode: countryCode },
    { count: 1 },
    { refetchOnMountOrArgChange: true }
  );

  const myElementRef = React.useRef(null);
  const myElementRefs = React.useRef(null);
  const myContact = React.useRef(null);

  const myPayment = React.useRef(null);
  const myBilling = React.useRef(null);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.substring(1);
      if (hash === "returns") {
        myElementRef.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "shipping") {
        myElementRefs.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "contact") {
        myContact.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "billing") {
        myBilling.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "payment") {
        myPayment.current.scrollIntoView({ behavior: "smooth" });
      }
    };
    window.addEventListener("hashchange", handleHashChange);
    handleHashChange();
    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, [window, window.location.hash]);

  return (
    <>
      <HelmetComponent title={"Terms and Conditions"} />
      <div className="statisc-page">
        <div className="container static-container">
          <div className="row static-row">
            <div className="col-md-10">
              <div
                className="static-container-card"
                style={{
                  textAlign: "left",
                  padding: "20px",
                  background: "#fcfcfc",
                  border: "1px solid #eee",
                  borderRadius: "7px",
                }}
              >
                <h1 style={{ padding: "20px 0px 20px 0px", fontWeight: 300, fontSize: "1.4rem" }}>
                  {t("Terms and Conditions")}
                </h1>

                <p>Last updated: 30 May 2026</p>

                <h4>1. Introduction</h4>
                <p>
                  Welcome to {Host?.domainName}. These Terms and Conditions (the "Terms") govern your access to and use
                  of {window.location.hostname}, including browsing, account registration, placing orders, making
                  payments, and using any related services offered through the website.
                </p>
                <p>
                  The website is operated by {Host?.domainName} LLC FZ  ("Company", "we",
                  "our", or "us"). By accessing or using our website, you agree to be bound by these Terms, together
                  with our Privacy Policy, Shipping Policy, Payment Policy, Returns, Refunds, Cancellation & Warranty
                  Policy, and any other policies displayed on our website.
                </p>
                <p>
                  If you do not agree with these Terms, you should not use the website or place an order. You may
                  contact us at {Host?.email}if you need assistance or clarification.
                </p>

                <h4>2. Communications</h4>
                <p>
                  By using our website or placing an order, you agree that we may contact you by email, phone, SMS,
                  WhatsApp, or other available communication methods for order updates, delivery coordination, customer
                  support, account matters, and service-related notices.
                </p>
                <p>
                  You may also choose to receive newsletters, promotions, or marketing communications from us. You may
                  opt out of marketing communications at any time by using the unsubscribe option, where available, or
                  by contacting us at {Host?.email}. Service-related and order-related communications may still be sent
                  where necessary to process your order or support your account.
                </p>

                <h4>3. Purchases and Order Acceptance</h4>
                <p>
                  If you wish to purchase any product made available through our website, you may be asked to provide
                  information relevant to your order, including your name, contact details, billing information,
                  shipping address, and payment details.
                </p>
                <p>
                  By placing an order, you confirm that the information you provide is accurate, complete, and current;
                  that you are legally authorized to use the selected payment method; and that you are purchasing the
                  product for lawful purposes.
                </p>
                <p>
                  After an order is placed, you may receive an order confirmation by email, SMS, WhatsApp, or another
                  available communication method. This confirmation means that we have received your order request. It
                  does not guarantee that the item has been dispatched.
                </p>
                <p>
                  We reserve the right to refuse or cancel an order before dispatch if the product is unavailable; there
                  is an obvious pricing, stock, image, title, or product description error; payment is not completed or
                  authorized; fraud, misuse, unauthorized activity, or suspicious activity is suspected; delivery cannot
                  be completed to the provided address; or the order violates these Terms or applicable law.
                </p>
                <p>
                  If an order is cancelled by us after payment has been received, the customer will receive a refund for
                  the cancelled item in accordance with our refund process.
                </p>

                <h4>4. Product Availability, Pricing, and Order Updates</h4>
                <p>
                  We make reasonable efforts to keep product prices, stock availability, product descriptions, images,
                  delivery estimates, and other product information accurate and updated on our website.
                </p>
                <p>
                  The price shown on the product page and at checkout is the price payable by the customer for that
                  order, subject to any applicable delivery charges, taxes, or fees clearly shown before payment.
                </p>
                <p>
                  We do not charge customers any additional amount after an order is placed without the customer's
                  express approval.
                </p>
                <p>
                  In rare cases, a product may become unavailable after an order is placed due to supplier-side stock
                  changes, fulfillment limitations, system updates, or other operational reasons. If this happens, we
                  will contact the customer promptly and offer one or more of the following options: wait for the
                  product to become available; choose an alternative product; or cancel the affected item and receive a
                  full refund for that item.
                </p>
                <p>
                  If there is an obvious pricing or product information error, we may cancel the affected order before
                  dispatch and issue a refund for any amount paid. We will not dispatch products at an incorrect price
                  where the error is clear and recognizable as a mistake.
                </p>
                <p>
                  We aim to ensure that the product information displayed on our website matches the information
                  provided in our product listings, advertisements, and checkout pages.
                </p>

                <h4>5. Refunds, Returns, Cancellations, and Warranty</h4>
                <p>
                  Refunds, returns, cancellations, damaged items, defective items, incorrect items, and warranty claims
                  are handled in accordance with our Returns, Refunds, Cancellation & Warranty Policy.
                </p>
                <p>
                  Customers may request support if the wrong item was delivered; the item arrived damaged; the item is
                  defective; the item does not match the product description on our website; the order was cancelled
                  before dispatch; or the item is eligible for warranty support.
                </p>
                <p>
                  We do not accept returns, refunds, or exchanges for change of mind, buyer's remorse, incorrect
                  selection by the customer, or products ordered by mistake, unless otherwise required by applicable law
                  or expressly stated on the product page.
                </p>
                <p>
                  Approved refunds are usually processed within 7 to 15 business days after approval. The actual time
                  for the refund to appear in the customer's account may depend on the bank, card provider, or payment
                  service provider.
                </p>
                <p>
                  For Cash on Delivery orders, approved refunds may be issued through bank transfer, store credit,
                  wallet credit, or another available refund method confirmed by our support team.
                </p>
                <p>
                  Nothing in these Terms affects the customer's right to request support for damaged, defective,
                  incorrect, or not-as-described products.
                </p>

                <h4>6. Content</h4>
                <p>
                  The content available on or through the website, including text, graphics, logos, images, product
                  information, design elements, page layouts, software, and other materials, is owned by{" "}
                  {Host?.domainName}, licensed to {Host?.domainName}, or used with permission, unless otherwise stated.
                </p>
                <p>
                  You may not copy, reproduce, modify, distribute, transmit, display, publish, sell, license, create
                  derivative works from, or use any website content for commercial purposes without our prior written
                  consent, except where such use is expressly permitted by applicable law.
                </p>

                <h4>7. Prohibited Uses</h4>
                <p>
                  You may use the website only for lawful purposes and in accordance with these Terms. You agree not to
                  use the website in any way that violates applicable law or regulation; exploits, harms, or attempts to
                  harm minors; sends spam or unauthorized promotional material; impersonates {Host?.domainName}, our
                  employees, another user, or any other person or entity; infringes the rights of others; or is
                  unlawful, fraudulent, abusive, threatening, harmful, or misleading.
                </p>
                <p>
                  You also agree not to interfere with the proper operation of the website; use automated tools such as
                  robots, spiders, scrapers, or similar systems without our prior written consent; introduce viruses,
                  malware, logic bombs, or other harmful materials; attempt to gain unauthorized access to our systems;
                  attack the website through denial-of-service or similar methods; manipulate ratings, reviews, or
                  feedback; or otherwise engage in conduct that may damage {Host?.domainName}, our customers, our
                  systems, or the website.
                </p>

                <h4>8. Analytics</h4>
                <p>
                  We may use third-party service providers and analytics tools to monitor, measure, and analyze website
                  traffic, customer behavior, performance, and usage trends. Such tools help us improve the website,
                  customer experience, product listings, advertising performance, and operational reliability.
                </p>
                <p>Use of analytics and tracking technologies is subject to our Privacy Policy and applicable law.</p>

                <h4>9. No Use by Minors</h4>
                <p>
                  The website is intended for use by individuals who are at least eighteen (18) years old or who are
                  using the website under the supervision and consent of a parent or legal guardian, where permitted by
                  applicable law.
                </p>
                <p>
                  By accessing or using the website, creating an account, or placing an order, you confirm that you have
                  the legal capacity to enter into these Terms or that you are using the website with appropriate
                  consent and supervision.
                </p>

                <h4>10. Accounts</h4>
                <p>
                  When you create an account with us, you agree to provide accurate, complete, and current information.
                  Inaccurate, incomplete, or outdated information may result in difficulty processing orders, delivery
                  issues, suspension of account access, or cancellation of orders.
                </p>
                <p>
                  You are responsible for maintaining the confidentiality of your account login details and for all
                  activity that occurs under your account. You must notify us immediately if you become aware of any
                  unauthorized use of your account or any security breach.
                </p>
                <p>
                  You may not use a username, account name, or profile information that impersonates another person or
                  entity, infringes third-party rights, or is offensive, misleading, unlawful, vulgar, or obscene.
                </p>
                <p>
                  We reserve the right to refuse service, suspend or terminate accounts, remove or edit content, or
                  cancel orders where necessary to protect the website, customers, our business, or comply with
                  applicable law.
                </p>

                <h4>11. Intellectual Property</h4>
                <p>
                  The website, its original content, features, functionality, design, layout, trademarks, service marks,
                  trade names, logos, and other intellectual property are owned by {Host?.domainName}, licensed to{" "}
                  {Host?.domainName}, or used with permission, unless otherwise stated.
                </p>
                <p>
                  Our trademarks and brand assets may not be used in connection with any product, service, website,
                  advertisement, or business without our prior written consent.
                </p>
                <p>
                  Third-party trademarks, brand names, product names, and logos appearing on the website belong to their
                  respective owners. Their appearance on the website does not imply endorsement, sponsorship, official
                  affiliation, or authorization unless expressly stated.
                </p>

                <h4>12. Intellectual Property Complaints</h4>
                <p>
                  We respect the intellectual property rights of others. If you believe that content available on our
                  website infringes your copyright, trademark, or other intellectual property rights, please contact us
                  at {Host?.email} with the subject line "Intellectual Property Complaint".
                </p>
                <p>
                  Your complaint should include your name and contact details; identification of the intellectual
                  property right allegedly infringed; the specific URL or location of the allegedly infringing content;
                  a description of why you believe the content infringes your rights; and confirmation that the
                  information provided is accurate and submitted in good faith.
                </p>
                <p>
                  We may review, remove, disable, restrict, or request further information regarding content that is the
                  subject of a complaint. Submitting false, misleading, or bad-faith complaints may expose the
                  complainant to liability under applicable law.
                </p>

                <h4>13. Product Information and Third-Party Data</h4>
                <p>
                  Product names, images, descriptions, specifications, availability, and other product information may
                  be obtained from manufacturers, suppliers, distributors, brand owners, marketplaces, or other
                  third-party data sources.
                </p>
                <p>
                  We make reasonable efforts to display accurate product information, but we do not guarantee that all
                  product information is always complete, current, or error-free. Where we become aware of an error, we
                  may correct the information, contact the customer, cancel the affected order before dispatch, or offer
                  an appropriate resolution.
                </p>
                <p>
                  Customers should review product details, specifications, size, compatibility, delivery timelines, and
                  warranty information before placing an order.
                </p>

                <h4>14. Error Reporting and Feedback</h4>
                <p>
                  You may provide feedback, suggestions, ideas, complaints, or error reports regarding the website,
                  products, services, or customer experience by contacting us at {Host?.email}.
                </p>
                <p>
                  By submitting feedback, you agree that we may use it to improve our website, services, products,
                  operations, customer support, and business processes without any obligation to compensate you. You
                  should not submit confidential or proprietary information unless specifically requested by us in
                  writing.
                </p>

                <h4>15. Links to Other Websites</h4>
                <p>
                  Our website may contain links to third-party websites or services that are not owned or controlled by{" "}
                  {Host?.domainName}.
                </p>
                <p>
                  {Host?.domainName} has no control over, and assumes no responsibility for, the content, privacy
                  policies, products, services, or practices of any third-party websites or services.
                </p>
                <p>
                  The inclusion of any third-party link does not mean that {Host?.domainName} endorses, sponsors, or is
                  officially affiliated with that third party, unless expressly stated by us in writing.
                </p>
                <p>
                  Customers are advised to review the terms, policies, and privacy practices of any third-party websites
                  they visit.
                </p>

                <h4>16. Disclaimer of Warranty</h4>
                <p>
                  Our website and services are provided on an "as available" basis. While we make reasonable efforts to
                  keep the website accurate, secure, and functional, we do not guarantee that the website will always be
                  uninterrupted, error-free, or free from technical issues.
                </p>
                <p>
                  Product warranties, where applicable, are handled according to the warranty information shown on the
                  product page, included with the product, or provided by the manufacturer, supplier, or seller.
                </p>
                <p>
                  This section does not limit any product warranty, return right, refund right, or consumer protection
                  right that cannot be excluded under applicable law.
                </p>

                <h4>17. Limitation of Liability</h4>
                <p>
                  To the maximum extent permitted by applicable law, {Host?.domainName} shall not be liable for
                  indirect, incidental, special, punitive, or consequential losses arising from the use of our website,
                  products, or services.
                </p>
                <p>
                  Where liability cannot be excluded under applicable law, our liability shall be limited to the amount
                  paid by the customer for the specific product giving rise to the claim.
                </p>
                <p>
                  Nothing in these Terms limits or excludes liability where such limitation or exclusion is not
                  permitted by applicable law.
                </p>

                <h4>18. Termination</h4>
                <p>
                  We may suspend or terminate your account, restrict access to the website, cancel orders, or refuse
                  service where we reasonably believe that you have breached these Terms, provided false or misleading
                  information, engaged in fraudulent or unlawful activity, misused the website, or created risk for{" "}
                  {Host?.domainName}, our customers, or third parties.
                </p>
                <p>
                  You may stop using the website at any time. Any provisions of these Terms that by their nature should
                  survive termination shall continue to apply, including provisions relating to intellectual property,
                  payment obligations, refunds, warranties, disclaimers, limitation of liability, governing law, and
                  dispute resolution.
                </p>

                <h4>19. Governing Law</h4>
                <p>
                  These Terms shall be governed by and interpreted in accordance with the laws of the United Arab
                  Emirates.
                </p>
                <p>
                  Any disputes arising from or relating to these Terms, the website, or purchases made through the
                  website shall be subject to the jurisdiction of the competent courts of the United Arab Emirates,
                  unless otherwise required by applicable law.
                </p>

                <h4>20. Changes to Service</h4>
                <p>
                  We reserve the right to withdraw, amend, suspend, update, or modify all or any part of the website,
                  services, product listings, features, or materials at any time where necessary for operational, legal,
                  security, technical, or business reasons.
                </p>
                <p>
                  We will not be liable if all or any part of the website is unavailable at any time or for any period
                  due to maintenance, technical issues, system updates, third-party service disruptions, or
                  circumstances beyond our reasonable control.
                </p>

                <h4>21. Amendments to Terms</h4>
                <p>
                  We may amend these Terms from time to time by posting the updated Terms on this website. The updated
                  Terms will apply from the date they are posted, unless otherwise stated.
                </p>
                <p>
                  You are responsible for reviewing these Terms periodically. Your continued use of the website after
                  updated Terms are posted means that you accept and agree to the revised Terms. If you do not agree to
                  the updated Terms, you should stop using the website.
                </p>

                <h4>22. Waiver and Severability</h4>
                <p>
                  No failure or delay by {Host?.domainName} in exercising any right or remedy under these Terms shall
                  constitute a waiver of that right or remedy.
                </p>
                <p>
                  If any provision of these Terms is held to be invalid, illegal, or unenforceable by a competent
                  authority, that provision shall be limited or removed to the minimum extent necessary, and the
                  remaining provisions shall remain in full force and effect.
                </p>

                <h4>23. Acknowledgement and Contact Information</h4>
                <p>
                  By using the website, creating an account, or placing an order, you acknowledge that you have read,
                  understood, and agreed to these Terms and the policies referenced in them.
                </p>
                <p>This website is operated by {Host?.domainName} LLC FZ .</p>
                <p>Business Address:</p>

                <p style={{ lineHeight: 2 }}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: Host?.address,
                    }}
                  ></div>
                  <MailOutlineIcon style={{ fontSize: "18px" }} /> {Host?.email} <br />
                  <PhoneIcon style={{ fontSize: "18px" }} /> {Host?.phone}
                  <br />
                  <PhoneIcon style={{ fontSize: "1.1rem", color: "#00000059" }} /> +971 4 836 9553
                </p>
                <p>Customer Support: 8:00 AM to 10:00 PM Dubai Time, 7 days a week</p>
                <p>Website: {window.location.hostname}</p>

                <p>&nbsp;</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TermsConditions;
